import React from 'react';

const ControllersBackground = () => {
  // Generate random positions for controllers
  const controllers = Array.from({ length: 25 }, (_, i) => ({
    id: i,
    x: Math.random() * 100,
    y: Math.random() * 100,
    size: 60 + Math.random() * 80,
    rotation: Math.random() * 360,
    type: Math.floor(Math.random() * 3),
    floatClass: `controller-float-${(i % 3) + 1}`
  }));

  // Different controller SVG paths
  const controllerPaths = [
    // Modern gamepad
    `M48 24c-13.255 0-24 10.745-24 24v16c0 4.418-3.582 8-8 8s-8-3.582-8-8V48c0-22.091 17.909-40 40-40s40 17.909 40 40v16c0 4.418-3.582 8-8 8s-8-3.582-8-8V48c0-13.255-10.745-24-24-24zm-20 32a4 4 0 108 0 4 4 0 00-8 0zm32 0a4 4 0 108 0 4 4 0 00-8 0zm-24-8h8v-8h8v8h8v8h-8v8h-8v-8h-8v-8z`,
    
    // Classic controller
    `M80 32H16a8 8 0 00-8 8v16a8 8 0 008 8h64a8 8 0 008-8V40a8 8 0 00-8-8zM28 52a4 4 0 110-8 4 4 0 010 8zm8-8h4v-4h4v4h4v4h-4v4h-4v-4h-4v-4zm32 8a4 4 0 110-8 4 4 0 010 8zm8 0a4 4 0 110-8 4 4 0 010 8z`,
    
    // Retro joystick
    `M48 8a8 8 0 00-8 8v48a8 8 0 0016 0V16a8 8 0 00-8-8zm0 72a16 16 0 1116 16 16 16 0 01-16-16z`
  ];

  return (
    <div className="controllers-background">
      {controllers.map((controller) => (
        <svg
          key={controller.id}
          className={`controller-icon ${controller.floatClass}`}
          width={controller.size}
          height={controller.size}
          viewBox="0 0 96 96"
          style={{
            left: `${controller.x}%`,
            top: `${controller.y}%`,
            transform: `rotate(${controller.rotation}deg)`
          }}
        >
          <path d={controllerPaths[controller.type]} />
        </svg>
      ))}
    </div>
  );
};

export default ControllersBackground;
